import { Content, ImgSection, Wrapper } from "./styles";
import { StyledButton } from "../../../../components/generic";
import src from "../../../../assets/images/Student aan het studeren.webp";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

export const SignUpForFreeSection = () => {
  const { t, i18n } = useTranslation("home");

  return (
    <Wrapper>
      <div>
        <Content>
          <div id="bold">
            {t("signUpForFree.p1")} <b>{t("signUpForFree.p2")}</b>{" "}
            {t("signUpForFree.p3")} <b>{t("signUpForFree.p4")}</b>{" "}
            {i18n.language === "gb" && t("signUpForFree.p5")}
          </div>
          <NavLink to={`/${i18n.language}/register?m=s`}>
            <StyledButton p="16px 32px">{t("buttons.signUp")}</StyledButton>
          </NavLink>
        </Content>
        <ImgSection>
          <img src={src} />
        </ImgSection>
      </div>
    </Wrapper>
  );
};
